import axios from 'axios';
import { BFF_URL, FRETEBRAS_LOGOUT_URL, NODE_ENV } from '@constants';
import { getCookie } from '@utils/cookies';

const apiService = axios.create({
  baseURL: BFF_URL,
  withCredentials: true,
  withXSRFToken: true,
  timeout: 60000,
  headers: {
    'content-Type': 'application/json',
    Accept: '/',
    'Cache-Control': 'no-cache',
  },
});

apiService.interceptors.request.use(
  (request) => {
    const accessToken = getCookie('_TOKEN_BFF');

    if (accessToken) {
      request.headers = {
        ...request.headers,
        Authorization: `Bearer ${accessToken}`,
      };
    }
    return request;
  },

  (err) => Promise.reject(err),
);

apiService.interceptors.response.use(
  (response) => response.data,
  (err) => {
    if (axios.isCancel(err)) {
      return Promise.reject(err);
    }

    if (err.response === undefined) {
      const error = new Error('Não foi possível conectar ao servidor.');

      return Promise.reject(error.stack);
    }

    if (err.response.status === 401 || err.response.status === 403) {
      if (NODE_ENV !== 'development')
        window.location.assign(FRETEBRAS_LOGOUT_URL);
      return Promise.reject();
    }

    return Promise.reject(err);
  },
);

export default apiService;
